import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../CSS/Global.css";
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useSidebar } from "../../SidebarContext";

const getFileIcon = (url) => {
    const urlmain = API_BASE_URL;
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext)) {
        return `${urlmain}${url}`;
    }
    if (["xlsx", "xls", "csv"].includes(ext)) return "/icons/excel.png";
    if (["pdf"].includes(ext)) return "/icons/pdf.webp";
    if (["doc", "docx"].includes(ext)) return "/icons/word.png";
    if (["ppt", "pptx"].includes(ext)) return "/icons/ppt.png";
    if (["mp4", "mov", "avi", "mkv"].includes(ext)) return "/icons/video.png";
    if (["mp3", "wav", "aac", "flac", "m4a"].includes(ext)) return "/icons/audio.png";
    if (["zip", "rar"].includes(ext)) return "/icons/zip.png";
    if (["txt", "cls"].includes(ext)) return "/icons/text.png";

    return "/icons/file.png";
};

const getFileType = (url) => {
    const ext = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "webp", "gif", "bmp", "svg"].includes(ext)) return "image";
    if (["xlsx", "xls", "csv"].includes(ext)) return "doc";
    if (["pdf", "doc", "docx", "ppt", "pptx", "txt", "cls"].includes(ext)) return "doc";
    if (["mp4", "mov", "avi", "mkv"].includes(ext)) return "video";
    if (["mp3", "wav", "aac", "flac", "m4a"].includes(ext)) return "audio";
    if (["zip", "rar"].includes(ext)) return "zip";
    return "other";
};

function MediaLibraryPage() {
    const [images, setImages] = useState([]);
    const [selectedImages, setSelectedImages] = useState([]);
    const [filterType, setFilterType] = useState("all");
    const [filterDate, setFilterDate] = useState("all");
    const [isBulkMode, setIsBulkMode] = useState(false);
    const [selectedImageForModal, setSelectedImageForModal] = useState(null);


    const user = getDecryptedUserFromCookie();
    const url = API_BASE_URL;


    const [formData, setFormData] = useState({
        title: "",
        alt_text: "",
        caption: "",
        imageFile: null,
        previewUrl: ""
    });

    // inside your component
    const [isEditing, setIsEditing] = useState(false);    // track edit mode
    const [previewFile, setPreviewFile] = useState(null); // store selected file

    // handle "Edit" button click
    const handleEdit = () => {
        setIsEditing(true);
    };


    useEffect(() => {
        if (selectedImageForModal) {
            setFormData({
                title: selectedImageForModal.title || "",
                alt_text: selectedImageForModal.alt_text || "",
                caption: selectedImageForModal.caption || "",
                imageFile: null,
                previewUrl: selectedImageForModal.url   // Initial preview
            });
        }
    }, [selectedImageForModal]);

    // Change handler
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (files && files[0]) {
            const file = files[0];
            setFormData(prev => ({
                ...prev,
                imageFile: file,
                previewUrl: URL.createObjectURL(file)
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const fetchImages = async () => {
        try {
            const res = await axios.get(`${url}/api/images/${user.main_id}`);
            setImages(res.data.reverse());
        } catch (err) {
            console.error("Error fetching images:", err);
        }
    };


    const handleSave = async () => {
        if (!selectedImageForModal) return;

        const endpoint = `${API_BASE_URL}/api/images/update/${selectedImageForModal.id}`;
        const form = new FormData();

        // Always append form fields
        form.append("title", formData.title);
        form.append("alt_text", formData.alt_text);
        form.append("caption", formData.caption);
        if (formData.imageFile) form.append("image", formData.imageFile);

        try {
            const res = await axios.put(endpoint, form, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            ;
            if (res.status === 200) {
                toast.success("Changes saved successfully!");
                setSelectedImageForModal(res.data.image);
                setIsEditing(false);
                setSelectedImageForModal(null)
                fetchImages();
            }
        } catch (err) {
            console.error("Save failed:", err.response || err);
            toast.error("Failed to save changes.");
        }
    };





    // Fetch images
    useEffect(() => {

        fetchImages();
    }, [url, user.main_id]);

    // Delete selected images
    const handleImageDelete = async () => {
        try {
            for (const img of selectedImages) {
                await axios.delete(`${url}/api/images/${img.id}`);
            }
            const all = await axios.get(`${url}/api/images/${user.main_id}`);
            setImages(all.data.reverse());
            setSelectedImages([]);
            setIsBulkMode(false);
            toast.success("Deleted successfully");
        } catch (err) {
            console.error("Delete failed", err);
        }
    };

    const handleImageClick = (image) => {
        if (isBulkMode) {
            setSelectedImages((prev) =>
                prev.some((img) => img.id === image.id)
                    ? prev.filter((img) => img.id !== image.id)
                    : [...prev, image]
            );
        } else {
            setSelectedImageForModal(image); // open modal
        }
    };

    const dateOptions = [
        "all",
        ...new Set(
            images.map((img) =>
                new Date(img.createdAt).toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                })
            )
        ),
    ];

    const filteredImages = images.filter((img) => {
        const fileTypeMatch = filterType === "all" || getFileType(img.url) === filterType;
        const imgMonthYear = new Date(img.createdAt).toLocaleDateString("en-US", {
            month: "long",
            year: "numeric",
        });
        const dateMatch = filterDate === "all" || imgMonthYear === filterDate;
        return fileTypeMatch && dateMatch;
    });

    return (
        <>
            <div className="media-container">
                {/* Toolbar */}
                <div className="media-toolbar">
                    <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                        <option value="all">All media items</option>
                        <option value="image">Images</option>
                        <option value="doc">Documents</option>
                        <option value="video">Videos</option>
                        <option value="audio">Audio</option>
                        <option value="zip">Zip/Rar</option>
                    </select>

                    <select value={filterDate} onChange={(e) => setFilterDate(e.target.value)}>
                        {dateOptions.map((d, i) => (
                            <option key={i} value={d}>
                                {d === "all" ? "All dates" : d}
                            </option>
                        ))}
                    </select>

                    <button
                        className="bulk-btn"
                        onClick={() => {
                            setIsBulkMode(true);
                            setSelectedImages([]);
                        }}
                    >
                        Bulk select
                    </button>

                    {/* <input type="text" placeholder="Search media" className="media-search" /> */}
                </div>

                {/* Bulk delete bar */}
                {isBulkMode && (
                    <div className="bulk-delete-bar">
                        <button onClick={handleImageDelete}>Delete permanently</button>
                        <button onClick={() => setIsBulkMode(false)}>Cancel</button>
                    </div>
                )}

                {/* Media Grid */}
                <div className="media-grid">
                    {filteredImages.length === 0 ? (
                        <p className="no-media-msg">No media items found</p>
                    ) : (
                        filteredImages.map((image) => {
                            const isSelected = selectedImages.some((img) => img.id === image.id);
                            return (
                                <div
                                    key={image.id}
                                    className={`media-item ${isSelected ? "selected" : ""}`}
                                    onClick={() => handleImageClick(image)}
                                >
                                    <img src={getFileIcon(image.url)} alt="media" />
                                    {isSelected && (
                                        <span className="checkmark">
                                            <i className="fa-solid fa-check"></i>
                                        </span>
                                    )}
                                </div>
                            );
                        }))}
                </div>
            </div>

            {/* Single Image Modal */}
            {/* Single Image Modal */}
            {selectedImageForModal && (
                <div className="medialibmodal-overlay">
                    <div className="medialibmodal-container">
                        <button
                            className="medialibmodal-close"
                            onClick={() => setSelectedImageForModal(null)}
                        >
                            ✕
                        </button>

                        <div className="medialibmodal-content">
                            {/* Left side: Preview */}
                            <div className="medialibmodal-left">
                                <div className="preview-wrapper">
                                    {/* {isEditing ? (
                                        <>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={handleChange}    // ✅ use handleChange to update formData
                                            />
                                            {formData.previewUrl && (
                                                <img
                                                    src={formData.previewUrl}
                                                    alt="Preview"
                                                    className="preview-img"
                                                />
                                            )}

                                        </>
                                    ) : ( */}
                                    <img
                                        src={getFileIcon(selectedImageForModal.url)}
                                        alt={selectedImageForModal.filename}
                                        className="preview-img"
                                    />
                                    {/* )} */}

                                    {/* {!isEditing && (
                                        <button className="edit-btn" onClick={handleEdit}>
                                            Edit
                                        </button>
                                    )} */}
                                </div>
                            </div>


                            {/* Right side: Details */}
                            <div className="medialibmodal-right">
                                <h2>Attachment details</h2>
                                <p><strong>Uploaded on:</strong> {new Date(selectedImageForModal.createdAt).toDateString()}</p>
                                <p><strong>Uploaded by:</strong> {selectedImageForModal.uploadedBy || "Admin"}</p>
                                {/* <p><strong>File name:</strong> {selectedImageForModal.filename}</p> */}
                                <p>
                                    <strong>File name:</strong>{" "}
                                    <a
                                        href={`${url}${selectedImageForModal.url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {`${url}${selectedImageForModal.url}`}
                                    </a>
                                </p>


                                <div className="medialibmodal-field">
                                    <label>Alternative Text</label>
                                    <input
                                        type="text"
                                        name="alt_text"
                                        value={formData.alt_text}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="medialibmodal-field">
                                    <label>Title</label>
                                    <input
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="medialibmodal-field">
                                    <label>Caption</label>
                                    <textarea
                                        name="caption"
                                        value={formData.caption}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* ✅ Save Button at bottom right */}
                                <div className="save-btn-container">
                                    <button className="save-btn" onClick={handleSave}>
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default MediaLibraryPage;
